import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { APP_CONFIG } from "../../constants/constants";
import svgIcons from "../../assets/svg/svgIcons";

interface HeaderViewProps {
  title: React.ReactNode;
  showBackButton?: boolean;
  backButtonCallback?: () => void;
  rightComponent?: React.ReactNode;
  showRefreshButton?: boolean;
  wrapperClassName?: string;
}

const HeaderView: FC<HeaderViewProps> = ({
  title,
  showBackButton = false,
  backButtonCallback,
  rightComponent = null,
  showRefreshButton = false, // enable when functionality gets implemented, also needs a callback
  wrapperClassName = `flex justify-between ${APP_CONFIG.DES.DASH.P_HORIZ} py-2`,
}) => {
  const { t } = useTranslation("translation", { keyPrefix: "admins" });
  const navigate = useNavigate();

  return (
    <header className={wrapperClassName}>
      <div className="flex items-center">
        {showBackButton && <img
          src={svgIcons.LeftArrowIcon}
          alt="left-arrow-icon"
          className="mr-4 p-2 bg-accent-blue-pale rounded-full cursor-pointer"
          onClick={() => {
            if (!!backButtonCallback) backButtonCallback();
            else navigate(-1)
          }}
        />}
        <h1 className="font-bold text-accent-blue-dark text-3xl leading-9">
          {title}
        </h1>
      </div>

      {/* Right Component */}
      {rightComponent && rightComponent}

      {/* Refresh Button */}
      {showRefreshButton && <div className="flex items-center">
        <button className="flex justify-between py-2">
          <p className="text-accent-blue-dark font-medium text-base leading-5">
            {t("refresh_data")}
          </p>
          <img src={svgIcons.RefreshIcon} alt="refresh-icon" className="pl-2 " />
        </button>
      </div>}
    </header>
  )
}

export default HeaderView;